// extracted by mini-css-extract-plugin
module.exports = {"container":"CentralLayout-module--container--3x47r"};